import React, { useEffect } from 'react';
import { cs } from '@bbkAdminUtils/css-utils';
import { Icons } from '@bbkAdminUtils/icons';

export const PreparingOverlay: React.FC<{ message?: string }> = ({
  message,
}) => {
  useEffect(() => {
    document.body.classList.add('no-scroll');
    return () => document.body.classList.remove('no-scroll');
  }, []);

  return (
    <div className="tw-absolute tw-h-screen tw-overflow-hidden">
      <div
        className={cs(
          'tw-h-full tw-w-full',
          'tw-fixed tw-bottom-0 tw-left-0 tw-right-0 tw-top-0 tw-z-10',
          'tw-flex tw-flex-col tw-items-center tw-justify-center',
          'tw-bg-white tw-text-sm tw-font-medium tw-text-primary-900'
        )}
      >
        <div className="tw-text-center">
          <div
            className={cs(
              'tw-inline-block tw-w-2/3 tw-text-cblogo',
              'tw-animate-[beat_3s_ease-in-out_infinite]'
            )}
          >
            {Icons.cbRetentionPulse}
          </div>
        </div>
        <div
          className={cs(
            'tw-w-full tw-text-center',
            // invisible before needed to balance the visible after:content
            // so when Loading... is rendered it would stay in the same place on the screen
            'before:tw-invisible before:tw-animate-[ellipsis_3s_ease-in-out_infinite]',
            'after:tw-animate-[ellipsis_3s_ease-in-out_infinite]'
          )}
        >
          {message || 'Preparing your workspace'}
        </div>
      </div>
    </div>
  );
};
